import React from 'react'
import Button from './Button'
import Panel from './Panel'

class SideBar extends React.Component {
  render() {
    const { isOpen, toggle } = this.props

    return(
      <>
        <Button isOpen={isOpen} toggle={toggle}/>
        <Panel isOpen={isOpen}/>
      </>
    )
  }
}

export default SideBar
